angular.module("ainapp")
    .controller("PayrollComponentController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {




            $scope.PageName = "PayrollComponent";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.Init = function () {
                $scope.PayrollComponent = {
                    Name: "",
                    Type: "",
                    Code: "",
                    IsSkipOnSalary: false,
                    Ishide: false,
                    IsPaidLeave: false,
                }

                $scope.load = 0;

            }
            $scope.Init();

            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        MainService.PayrollComponentsInView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error($scope.LanguageData.NetworkError);
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Name: {
                                type: "string",
                                editable: false,
                            },
                            Type: {
                                type: "string",
                                editable: false,
                            },

                            Code: {
                                type: "string",
                                editable: false,
                            },
                            IsSkipOnSalary: {
                                type: "boolean",
                                editable: false,
                            },
                            Ishide: {
                                type: "boolean",
                                editable: false,
                            },

                            IsPaidLeave: {
                                type: "boolean",
                                editable: false,
                            },


                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 40,

                group: [{
                    field: "Type",
                    }],
            });

            $scope.KendoGridOptions = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 40,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: false,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },

                columns: [
                    {
                        field: "Type",
                        title: "Type",
                        headerTemplate: "{{LanguageData.Type}}",
                        hidden: true,
                        },
                    {
                        field: "Name",
                        title: "Grade",
                        headerTemplate: "{{LanguageData.Name}}",
                        },
                    {
                        field: "Code",
                        title: "Code",
                        headerTemplate: "{{LanguageData.Code}}",
                        },
                    {
                        field: "IsSkipOnSalary",
                        title: "Skip On Salary",
                        template: "<p><i ng-if='dataItem.IsSkipOnSalary'>Yes</i></p>"
                        },
                    {
                        field: "Ishide",
                        title: "Hide",
                        template: "<p><i ng-if='dataItem.Ishide'>Hidden</i></p>"
                        }, {
                        field: "IsPaidLeave",
                        title: "Paid Leave?",
                        template: "<p><i ng-if='dataItem.IsPaidLeave'>Yes</i></p>"
                        },
                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}  ",
                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-trash'  ng-click='DeleteAccType(dataItem)'></button>  ",
                        width: '80px'
                    },
                    ],
            };

            $scope.Update = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.sync();
            }
            $scope.Cancel = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.cancelChanges();
            }

            $scope.SelectedDataForDelete = {};
            $scope.DeleteAccType = function (data) {
                if (!$scope.PageAccessInfo.IsRemove) {
                    toastr.info($scope.LanguageData.YouDontHaveAccessToDeleteData);
                } else {
                    $scope.SelectedDataForDelete = data;
                    $("#deleteModal").modal("show");
                }
            }

            $scope.deleteWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeletePayrollComponent($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data) {
                        $('#deleteModal').modal('hide');
                        toastr.success($scope.LanguageData.Deleted);
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataForDelete = {};
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error($scope.LanguageData.NetworkError);
                    $.LoadingOverlay("hide");
                });
            }


            $scope.Edit = function (data) {
                $scope.PayrollComponent = data;
                //$scope.$apply();
            }




            $scope.AddData = function () {
                if (!$scope.PageAccessInfo.IsAdd && !$scope.PayrollComponent.Id > 0) {
                    toastr.info($scope.LanguageData.YouDontHaveAccessToAddData);
                } else if (!$scope.PageAccessInfo.IsEdit && $scope.PayrollComponent.Id > 0) {
                    toastr.info($scope.LanguageData.YouDontHaveAccessToEditData);
                } else if ($scope.PayrollComponent.Name == "") {
                    toastr.warning($scope.LanguageData.EntertheGrade);

                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.AddPayrollComponent($scope.PayrollComponent).then(function (response) {
                        if (response.data) {
                            $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                            toastr.success($scope.LanguageData.Success);
                            $scope.Init();
                        } else {
                            toastr.error($scope.LanguageData.Error);
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error($scope.LanguageData.NetworkError);
                        $.LoadingOverlay("hide");
                    });
                }
            }

                }])
